import { render, staticRenderFns } from "./PagePaymentCards.vue?vue&type=template&id=88de4fa8&"
import script from "./PagePaymentCards.vue?vue&type=script&lang=ts&"
export * from "./PagePaymentCards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports